export const blockIconsNotificationEventAvailable = (
	<span className='material-symbols-outlined'>event_available</span>
);
